export class ThemeStyles {
    public static lightMode = "app-light";
    public static darkMode = "app-dark";

    public static readonly modes = [
        {"value":"app-dark","displayName":"Dark Mode"},
        {"value":"app-light","displayName":"Light Mode"},
    ]
}